module.exports = __webpack_public_path__ + "img/back.62977d52.svg";